// import React, { useState } from 'react';
// import { Box, Container, Typography, Link } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import { searchHotelsByLocation } from '../Utils/hotelSearch';
// import Loader from './Loader';
// import TermsModal from './TermsModal';
// import PrivacyModal from './PrivacyModal';
// import DisclaimerModal from './DisclaimerModal';

// const Footer = () => {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);
//   const [termsOpen, setTermsOpen] = useState(false);
//   const [privacyOpen, setPrivacyOpen] = useState(false);
//   const [disclaimerOpen, setDisclaimerOpen] = useState(false);

//   const handleCityHotelClick = async (locationId, locationName, event) => {
//     event.preventDefault();
//     setLoading(true);
//     try {
//       await searchHotelsByLocation({ locationId, locationName, navigate });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const footerSections = [
//     {
//       title: 'Top destinations',
//       links: [
//         { text: 'Hotels in Dubai', href: '#', onClick: (e) => handleCityHotelClick(213394, 'Dubai', e) },
//         { text: 'Hotels in Mumbai', href: '#', onClick: (e) => handleCityHotelClick(357389, 'Mumbai', e) },
//         { text: 'Hotels in Delhi', href: '#', onClick: (e) => handleCityHotelClick(227760, 'Delhi', e) },
//         { text: 'Hotels in Bangalore', href: '#', onClick: (e) => handleCityHotelClick(312030, 'Bangalore', e) },
//         { text: 'Hotels in Pune', href: '#', onClick: (e) => handleCityHotelClick(333627, 'Pune', e) },
//       ],
//     },
//     {
//       title: 'Top countries & regions',
//       links: [
//         { text: 'Hotels in Maldives', href: '#', onClick: (e) => handleCityHotelClick(227609, 'Maldives', e) },
//         { text: 'Hotels in Singapore', href: '#', onClick: (e) => handleCityHotelClick(246673, 'Singapore', e) },
//         { text: 'Hotels in Thailand', href: '#' },
//         { text: 'Hotels in Sri Lanka', href: '#' },
//         { text: 'Hotels in Malaysia', href: '#' },
//       ],
//     },
//     {
//       title: 'Support',
//       links: [
//         { text: 'Your bookings', href: '/transaction-history' },
//         { text: 'Contact us', href: '/contact-us', onClick: (e) => { e.preventDefault(); navigate('/contact-us'); } },
//       ],
//     },
//     {
//       title: 'Policies',
//       links: [
//         { text: 'Terms & Conditions', href: '#', onClick: (e) => { e.preventDefault(); setTermsOpen(true); } },
//         { text: 'Privacy Policy', href: '#', onClick: (e) => { e.preventDefault(); setPrivacyOpen(true); } },
//         { text: 'Disclaimer', href: '#', onClick: (e) => { e.preventDefault(); setDisclaimerOpen(true); } },
//       ],
//     },
//     {
//       title: 'Other Information',
//       links: [
//         { text: 'About us', href: '/about-us', onClick: (e) => { e.preventDefault(); navigate('/about-us'); } },
//       ],
//     },
//   ];

//   return (
//     <>
//       {loading && <Loader />}
//       <TermsModal open={termsOpen} onClose={() => setTermsOpen(false)} />
//       <PrivacyModal open={privacyOpen} onClose={() => setPrivacyOpen(false)} />
//       <DisclaimerModal open={disclaimerOpen} onClose={() => setDisclaimerOpen(false)} />
//       <Box
//         sx={{
//           bgcolor: '#f5f5f5',
//           pt: 8,
//           pb: 4,
//           mt: 6,
//         }}
//       >
//         <Container 
//           maxWidth="xl" 
//           sx={{ 
//             px: { xs: 3, sm: 4, md: 8 } // Increased padding
//           }}
//         >
//           <Box
//             sx={{
//               display: 'flex',
//               flexWrap: 'wrap',
//               gap: { xs: 4, md: 6 },
//               justifyContent: { xs: 'flex-start', md: 'space-between' },
//             }}
//           >
//             {footerSections.map((section, index) => (
//               <Box
//                 key={index}
//                 sx={{
//                   minWidth: { xs: '100%', sm: '45%', md: 'auto' },
//                   flex: { md: '1 1 0' },
//                   maxWidth: { md: '200px' },
//                 }}
//               >
//                 <Typography
//                   variant="subtitle1"
//                   sx={{
//                     color: '#1a1a1a',
//                     fontWeight: 600,
//                     mb: 2.5,
//                     fontSize: '1rem',
//                   }}
//                 >
//                   {section.title}
//                 </Typography>
//                 <Box
//                   sx={{
//                     display: 'flex',
//                     flexDirection: 'column',
//                     gap: 1.5,
//                   }}
//                 >
//                   {section.links.map((link, linkIndex) => (
//                     <Link
//                       key={linkIndex}
//                       href={link.href}
//                       onClick={link.onClick}
//                       sx={{
//                         color: '#0071c2',
//                         textDecoration: 'none',
//                         fontSize: '0.875rem',
//                         lineHeight: '1.5',
//                         '&:hover': {
//                           textDecoration: 'underline',
//                           color: '#004cb8',
//                         },
//                       }}
//                     >
//                       {link.text}
//                     </Link>
//                   ))}
//                 </Box>
//               </Box>
//             ))}
//           </Box>

//           {/* Divider */}
//           <Box
//             sx={{
//               height: '1px',
//               bgcolor: '#ddd',
//               my: 4,
//             }}
//           />

//           {/* Expedia Group Logo */}
//           <Box 
//             sx={{ 
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent:"center",
//               gap: 2,
//             }}
//           >
           
//             <Typography
//               variant="caption"
//               sx={{
//                 color: '#666',
//                 fontSize: '0.75rem',
//               }}
//             >
//               © 2025 TripTripIndia.com is a dream hotel booking website. All rights reserved.
//             </Typography>
//           </Box>
//         </Container>
//       </Box>
//     </>
//   );
// };

// export default Footer;
import React, { useState } from "react";
import { Box, Container, Typography, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { searchHotelsByLocation } from "../Utils/hotelSearch";
import Loader from "./Loader";
import TermsModal from "./TermsModal";
import PrivacyModal from "./PrivacyModal";
import DisclaimerModal from "./DisclaimerModal";
import { tokens } from "../theme/tokens";

const Footer = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [disclaimerOpen, setDisclaimerOpen] = useState(false);

  const handleCityHotelClick = async (locationId, locationName, event) => {
    event.preventDefault();
    setLoading(true);
    try {
      await searchHotelsByLocation({ locationId, locationName, navigate });
    } finally {
      setLoading(false);
    }
  };

  const footerSections = [
    {
      title: 'Top destinations',
      links: [
        { text: 'Hotels in Dubai', href: '#', onClick: (e) => handleCityHotelClick(213394, 'Dubai', e) },
        { text: 'Hotels in Mumbai', href: '#', onClick: (e) => handleCityHotelClick(357389, 'Mumbai', e) },
        { text: 'Hotels in Delhi', href: '#', onClick: (e) => handleCityHotelClick(227760, 'Delhi', e) },
        { text: 'Hotels in Bangalore', href: '#', onClick: (e) => handleCityHotelClick(312030, 'Bangalore', e) },
        { text: 'Hotels in Pune', href: '#', onClick: (e) => handleCityHotelClick(333627, 'Pune', e) },
      ],
    },
    {
      title: 'Top countries & regions',
      links: [
        { text: 'Hotels in Maldives', href: '#', onClick: (e) => handleCityHotelClick(227609, 'Maldives', e) },
        { text: 'Hotels in Singapore', href: '#', onClick: (e) => handleCityHotelClick(246673, 'Singapore', e) },
        { text: 'Hotels in Thailand', href: '#' },
        { text: 'Hotels in Sri Lanka', href: '#' },
        { text: 'Hotels in Malaysia', href: '#' },
      ],
    },
    {
      title: 'Support',
      links: [
        { text: 'Your bookings', href: '/transaction-history' },
        { text: 'Contact us', href: '/contact-us', onClick: (e) => { e.preventDefault(); navigate('/contact-us'); } },
      ],
    },
    {
      title: 'Policies',
      links: [
        { text: 'Terms & Conditions', href: '#', onClick: (e) => { e.preventDefault(); setTermsOpen(true); } },
        { text: 'Privacy Policy', href: '#', onClick: (e) => { e.preventDefault(); setPrivacyOpen(true); } },
        { text: 'Disclaimer', href: '#', onClick: (e) => { e.preventDefault(); setDisclaimerOpen(true); } },
      ],
    },
    {
      title: 'Other Information',
      links: [
        { text: 'About us', href: '/about-us', onClick: (e) => { e.preventDefault(); navigate('/about-us'); } },
      ],
    },
  ];

  return (
    <>
      {loading && <Loader />}
      <TermsModal open={termsOpen} onClose={() => setTermsOpen(false)} />
      <PrivacyModal open={privacyOpen} onClose={() => setPrivacyOpen(false)} />
      <DisclaimerModal open={disclaimerOpen} onClose={() => setDisclaimerOpen(false)} />
      
      <Box
        component="footer"
        sx={{
          background: `linear-gradient(180deg, ${tokens.paper} 0%, ${tokens.surface} 100%)`,
          borderTop: `1px solid ${tokens.border}`,
          mt: { xs: 6, md: 10 },
          position: "relative",
        }}
      >
        <Container 
          maxWidth="xl" 
          sx={{ 
            px: { xs: 3, sm: 4, md: 8 },
            py: 6,
          }}
        >
          {/* Main Footer Content */}
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                sm: 'repeat(2, 1fr)',
                md: 'repeat(3, 1fr)',
                lg: 'repeat(5, 1fr)',
              },
              gap: { xs: 4, md: 5 },
              mb: 5,
            }}
          >
            {footerSections.map((section, index) => (
              <Box
                key={index}
                sx={{
                  transition: 'transform 0.2s ease',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                  },
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: tokens.text,
                    fontWeight: 700,
                    mb: 3,
                    fontSize: "0.95rem",
                    letterSpacing: "0.04em",
                    textTransform: "uppercase",
                    position: "relative",
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      bottom: -8,
                      left: 0,
                      width: 40,
                      height: 2,
                      background: `linear-gradient(90deg, ${tokens.brand}, ${tokens.accent})`,
                      borderRadius: 1,
                    },
                  }}
                >
                  {section.title}
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                  }}
                >
                  {section.links.map((link, linkIndex) => (
                    <Link
                      key={linkIndex}
                      href={link.href}
                      onClick={link.onClick}
                      sx={{
                        color: tokens.textMuted,
                        textDecoration: "none",
                        fontSize: "0.9rem",
                        lineHeight: 1.6,
                        transition: "color 0.2s ease, transform 0.2s ease",
                        position: "relative",
                        pl: 0,
                        "&:hover": {
                          color: tokens.accent,
                          transform: "translateX(4px)",
                          "&::before": {
                            opacity: 1,
                            transform: "translateX(0)",
                          },
                        },
                        "&::before": {
                          content: '"→"',
                          position: "absolute",
                          left: -20,
                          color: tokens.accent,
                          opacity: 0,
                          transform: "translateX(-10px)",
                          transition: "all 0.2s ease",
                        },
                      }}
                    >
                      {link.text}
                    </Link>
                  ))}
                </Box>
              </Box>
            ))}
          </Box>

          {/* Elegant Divider */}
          <Box
            sx={{
              height: 1,
              background: `linear-gradient(90deg, transparent, ${tokens.borderStrong}, transparent)`,
              my: 4,
            }}
          />

          {/* Copyright Section */}
          <Box 
            sx={{ 
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: 'center',
              justifyContent: 'center',
              gap: 2,
              textAlign: 'center',
              py: 2,
            }}
          >
            <Typography
              variant="body2"
              sx={{
                color: tokens.textMuted,
                fontSize: "0.875rem",
                fontWeight: 400,
                "& strong": {
                  color: tokens.brand,
                  fontWeight: 700,
                },
              }}
            >
              © 2025 <strong>TripTripIndia.com</strong> is a dream hotel booking website. All rights reserved.
            </Typography>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Footer;